/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2023.
 */

import { sendGTMLoginOpenEvent } from '@/data/events/handlers/gtm/LoginOpen';
import { GTMLoginOpenPayload } from '@/data/types/GTM';

type LoginOpenDelegatorProps = {
	gtm?: GTMLoginOpenPayload;
};

export const loginOpenDelegator = async (payload: LoginOpenDelegatorProps) => {
	const { gtm } = payload;
	if (gtm) {
		await sendGTMLoginOpenEvent(gtm);
	}
};
